import ConsumerOperationItem from './ConsumerOperationItem';

export default ConsumerOperationItem;
